import { useState } from 'react'
import { useSelector } from 'react-redux'

const useRazorpay = () => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const { userDetails } = useSelector((state) => state.auth)

  const initiatePayment = async ({ orderId, description }) => {
    setLoading(true)
    setError(null)

    try {
      if (typeof window.Razorpay === 'undefined') {
        throw new Error(
          'Razorpay SDK is not loaded. Please check your script inclusion.',
        )
      }

      return new Promise((resolve, reject) => {
        const options = {
          key: process.env.REACT_APP_RAZORPAY_KEY,
          order_id: orderId,
          currency: 'INR',
          retry: { enabled: true, max_count: 4 },
          ...(description && { description }),
          handler: (response) => {
            console.log('Payment successful:', response)
            resolve(response)
          },
          prefill: {
            name: userDetails?.data?.name ?? '',
            contact: userDetails?.data?.contact_no ?? '',
          },
          modal: {
            ondismiss: () => {
              console.warn('Payment modal closed by user')
              reject(new Error('Payment modal closed by user'))
            },
          },
        }

        const rzp = new window.Razorpay(options)
        rzp.on('payment.failed', (response) => {
          console.error('Payment failed:', response.error)
          reject(new Error(response.error.description || 'Payment failed'))
        })

        rzp.open()
      })
    } catch (err) {
      setError(err.message || 'An error occurred during payment initiation.')
      return null
    } finally {
      setLoading(false)
    }
  }

  return {
    initiatePayment,
    loading,
    error,
  }
}

export default useRazorpay
